<template>
  <div class="page resourcePool_list">
    <div
      :style="{
        background: '#f0f2f5',
      }"
    >
      <div class="width_1200px">
        <el-menu
          default-active="paper"
          mode="horizontal"
          background-color="#f0f2f5"
          text-color="#000"
          @select="handleSelect"
        >
          <!-- <el-menu-item index="medium">音视频库</el-menu-item>
          <el-menu-item index="file">文件库</el-menu-item> -->
          <el-menu-item index="paper">试题库</el-menu-item>
        </el-menu>
      </div>
    </div>
    <section class="width_1200px">
      <div class="search_div">
        <div class="add_resource">
          <img src="@/assets/images/resourcePool/icon_1.png" alt="" />
          <p>
            {{ currentResource === "medium" ? "上传音视频" : currentResource === "file" ? "上传文件" : "新增试题" }}
          </p>
        </div>
        <div class="search_data">
          <div>
            <label>题目id</label>
            <el-input v-model="input" placeholder="请输入内容"></el-input>
          </div>

          <div>
            <label>创建人</label>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>

          <div>
            <label>题目类型</label>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>

          <div>
            <label>文件类型</label>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>

          <div>
            <label>文件类型</label>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>

          <div>
            <label>文件类型</label>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>

          <div>
            <label>文件类型</label>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="btns">
            <el-button class="btn" type="primary">查询</el-button>
            <el-button class="btn">重置</el-button>
          </div>
        </div>
      </div>
      <div class="table_div">
        <el-table
          :header-cell-style="{
            background: '#F5F5F5',
            color: '#464C5B',
          }"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column fixed align="center" prop="date" label="题目id" width="150"> </el-table-column>
          <el-table-column align="center" prop="name" label="题干" width="120"> </el-table-column>
          <el-table-column align="center" prop="province" label="年级册次" width="120"> </el-table-column>
          <el-table-column align="center" prop="city" label="类型" width="120"> </el-table-column>
          <el-table-column align="center" prop="address" label="标签"> </el-table-column>
          <el-table-column align="center" prop="zip" label="难度"> </el-table-column>
          <el-table-column align="center" prop="zip" label="创建时间"> </el-table-column>
          <el-table-column align="center" prop="zip" label="状态"> </el-table-column>
          <el-table-column align="center" prop="zip" label="创建人"> </el-table-column>
          <el-table-column align="center" prop="zip" label="操作"> </el-table-column>
        </el-table>
        <el-pagination class="pagination_div" background layout="prev, pager, next" :total="1000"> </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tableData: [],
      currentResource: "paper",
    };
  },
  methods: {
    handleSelect(key) {
      this.currentResource = key;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/styles/public.less";

.resourcePool_list {
  .search_div {
    width: 100%;
    margin-top: 20px;
    display: flex;
    .add_resource {
      height: 140px;
      cursor: pointer;
      margin-right: 20px;
      width: 140px;
      background-image: linear-gradient(#e9e7f7, #ffffff);
      .flex_align_items;
      flex-direction: column;
      position: relative;
      border-radius: 6px;
      > img {
        width: 114px;
        height: 114px;
      }
      > p {
        position: absolute;
        bottom: 22px;
        font-size: 16px;
        font-family: SourceHanSansCN-Light, SourceHanSansCN;
        font-weight: 300;
        color: #333333;
      }
    }
    .search_data {
      height: 100%;
      background-image: linear-gradient(#ecf5fb, #ffffff);
      border-radius: 6px;
      width: 100%;
      padding: 20px 30px;
      display: flex;
      flex-wrap: wrap;
      .btns {
        .btn {
          width: 124px;
          height: 40px;
          margin: 0 35px;
        }
      }
      > div {
        margin-right: 30px;
        margin-top: 20px;
        .flex_align_items;
        > label {
          max-width: 56px;
          min-width: 56px;
          font-size: 14px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #333333;
          margin-right: 10px;
          text-align: right;
        }
      }
    }
  }
  .table_div {
    margin-top: 30px;
    .pagination_div {
      margin: 30px 0;
    }
  }
}
/deep/.el-input__inner {
  background: transparent;
  width: 320px;
  height: 40px;
}
</style>
